import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'
import configs from './configs'
import i18nL10n from './i18nL10n'
import keywordSearch from './keywordSearch'
import products from './products'
import publication from './publication'
import search from './search'
import users from './users'
import overview from './overview'
import page from './page'
import header from './header'
import loggedInUser from './loggedInUser'
import cookieConsent from './cookieConsent'
import recognition from './recognition'

const createRootReducer = reducers =>
  combineReducers(
    Object.entries(reducers).reduce((rootReducer, [name, slice]) => {
      rootReducer[name] = slice.reducer
      return rootReducer
    }, {})
  )

const isInternalDebug = () => {
  if (typeof window === 'undefined') return false
  if (sessionStorage.getItem('rtkdt') === 'true') return true
  return false
}

const combinedReducer = createRootReducer({
  configs,
  i18nL10n,
  keywordSearch,
  products,
  publication,
  search,
  users,
  overview,
  page,
  header,
  loggedInUser,
  cookieConsent,
  recognition
})

export const makeStore = (preloadedState = {}) => {
  return configureStore({
    reducer: combinedReducer,
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production' || isInternalDebug()
  })
}

export const reduxWrapper = createWrapper(makeStore)
